import React from "react";

function DataExporterProgress({ inProgress, progressPercent = 0 }) {
  return inProgress ? (
    <div className="progress-bar-container" data-testid="download-progress">
      <span
        data-testid="download-progress-bar"
        style={{ width: `${progressPercent}%` }}
      ></span>
    </div>
  ) : null;
}

export default DataExporterProgress;
